import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Add, DataArray, Error, ErrorOutline, Save, Work } from "@mui/icons-material";
import ActionButton, { ConditionalOutlinedButton } from "../../components/commonComponents/Buttons/ActionButton";
import { HtmlTooltip, SpaceBetweenStack, StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import AddNewCampaign from "./ModalContent/AddCampaign";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { checkUserPermissions, pageAccessAllowed } from "../../api_calls/userManagement";
import CampaignList from "./listings/CampaignList";
import CampaignListFilters from "./filters/CampaignListFilters";
import { resetCampaignSheetData } from "../../api_calls/campaignSheet";
import { clearCampaignDetails, resetBrandReportView } from "../../api_calls/utils";
import { useSelector } from "react-redux";
import WorkspaceSections from "./ModalContent/WorkspaceSections";

const Campaigns = () => {
  const Campaigns = useSelector((state) => state.userSelections);
  const [newCampaignModal, setNewCampaignModal] = useState(false);
  const [newWorkspaceSectionModal, setNewWorkspaceSectionModal] = useState(false);

  // check edit permission for the campaigns
  const checkEditAccess = pageAccessAllowed(["campaign_list_can_edit"], []);
  const allowedAccessRights = checkUserPermissions();
  const permissionScope = allowedAccessRights.allowed_access;

  const showErrorForSectionButton = typeof Campaigns.workspace_report_sections !== "undefined" && Campaigns.workspace_report_sections !== null && Campaigns.workspace_report_sections.length > 0 ? Campaigns.workspace_report_sections.filter(sec => sec.type === "impression").length === 0 : true;

  React.useEffect(() => {
    resetBrandReportView();
    clearCampaignDetails();
  }, []);

  return (
    <>
      {/* ========== main component body =========== */}
      <StyledMainBox component="main">
        {/* <Box height={30} /> */}
        <SpaceBetweenStack
          direction={"row"}
          spacing={2}
          width={"100%"}
          justifyContent={"space-between"}
          display={"flex"}
        >
          <h1>Contact-based Campaigns</h1>

          {/* -- section button to configure campaign analytics tab settings at workspace level -- */}
          {
            permissionScope.campaign_reports_settings_can_view === true && (
              <Box sx={{ position: "relative", display: "inline-block" }}>
                <ConditionalOutlinedButton
                  onClick={(e) => {
                    e.preventDefault();
                    setNewWorkspaceSectionModal(true);
                  }}
                  ariaText={"addWorkSpaceSections"}
                  label={"Sections"}
                  selected={false}
                />
                {/* Info/Error Icon: will only show if there's no impression dashboard added */}
                {
                  showErrorForSectionButton && (
                    <HtmlTooltip title={
                      <Box width={150}>
                        <StyledMainBox>
                          <Typography variant="body2">
                            Warning: This workspace has no Impressions dashboard saved for new reports! Automated publishing of Impressions Reports is disabled.
                          </Typography>
                        </StyledMainBox>
                      </Box>}
                    >
                      <Error
                        sx={{
                          position: "absolute",
                          left: -10,   // adjust to move horizontally
                          bottom: 5,  // adjust to move vertically
                          color: "#AF3241",
                          backgroundColor: "#fff",
                          borderRadius: "50%",
                        }}
                      />
                    </HtmlTooltip>
                  )
                }
              </Box>
            )
          }

        </SpaceBetweenStack>
        <Box height={30} />
        {/* ============ Action button =========== */}
        {checkEditAccess.success === true && (
          <Stack direction="row" spacing={2}>
            <ActionButton
              onClick={(e) => {
                e.preventDefault();
                setNewCampaignModal(true);
              }}
              label={"New Campaign"}
              icon={<Add />}
            />
          </Stack>
        )}

        {/* ============== campaign listing ============ */}
        <Box height={30} />
        {/* -------- filters ------- */}
        {
          typeof Campaigns.campaign_names_info !== "undefined" && typeof Campaigns.companies_info !== "undefined" && <CampaignListFilters />
        }

        <Box height={30} />
        <CampaignList />
      </StyledMainBox>
      {/* ----- new campaign modal ----- */}
      {newCampaignModal && (
        <AddNewCampaign
          open={newCampaignModal}
          onClose={() => {
            setNewCampaignModal(false);
            resetCampaignSheetData();
          }}
          size={"md"}
          closeModal={() => {
            setNewCampaignModal(false);
            resetCampaignSheetData();
          }}
          usedFor={"add"}
        />
      )}
      {/* ---------- workspace section modal ------------ */}

      {newWorkspaceSectionModal && (
        <WorkspaceSections
          open={newWorkspaceSectionModal}
          size={"lg"}
          closeModal={() => {
            setNewWorkspaceSectionModal(false);
          }}
        />
      )}

    </>
  );
};

export default AccessControl(Campaigns, ["campaign_list_can_view", "campaign_list_can_edit"], [], ["campaigns_section", "campaign_list"]);
